import { DateTime } from 'luxon'
import * as Sentry from '@sentry/react-native'
import * as Stores from '../stores'

export function useCardApplicationPlatform() {
  const { platform } = Stores.CardApplicationApi.endpoints[
    'GET /card/onboarding/applications'
  ].useQuery(
    {},
    {
      selectFromResult({ data, isLoading, isUninitialized, isSuccess, error }) {
        if (isUninitialized || isLoading) return { platform: 'LOADING' as const }

        if (!isSuccess) {
          Sentry.captureException(error ?? 'Failed to fetch card application platform')
          return { platform: 'ERROR' as const }
        }

        const { applications, eligibility } = data
        const newest = [...applications].sort(
          (a, b) =>
            DateTime.fromISO(b.updatedAt).toMillis() - DateTime.fromISO(a.updatedAt).toMillis(),
        )[0]

        return {
          platform:
            newest?.platform ??
            (eligibility.canStartCardApplication ? eligibility.platform : 'APPLICATIONS_DISABLED'),
        } as const
      },
    },
  )

  return platform
}

export const isResolvedPlatform = (platform: ReturnType<typeof useCardApplicationPlatform>) =>
  platform !== 'LOADING' && platform !== 'ERROR' && platform !== 'APPLICATIONS_DISABLED'
